var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cards
    ? _c(
        "div",
        { staticClass: "pricing-plans" },
        [
          _c(
            "v-row",
            { staticClass: "pricing-plans__row", attrs: { variant: "flex" } },
            [
              _c("v-column", { attrs: { large: 12 } }, [
                _c(
                  "div",
                  { staticClass: "pricing-plans__head" },
                  [
                    _c("v-typo", {
                      staticClass: "pricing-plans__headline",
                      attrs: { variant: "h1" },
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("pricing.head.headline"))
                      }
                    }),
                    _vm._v(" "),
                    _c("v-typo", {
                      staticClass: "pricing-plans__perex",
                      attrs: { variant: "body-perex" },
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("pricing.head.perex"))
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            {
              staticClass: "pricing-plans__row",
              attrs: { horizontal: "center", variant: "flex" }
            },
            _vm._l(_vm.cards, function(card, cardIndex) {
              return _c(
                "v-column",
                {
                  key: "pricing-plnas-card-" + cardIndex,
                  staticClass: "pricing-plans__body"
                },
                [
                  _c("v-price-card", {
                    attrs: { card: card, "show-button": _vm.showButton }
                  })
                ],
                1
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            { staticClass: "pricing-plans__row", attrs: { variant: "flex" } },
            [
              _c("v-column", { attrs: { large: 12 } }, [
                _c(
                  "div",
                  { staticClass: "pricing-plans__bottom" },
                  [
                    _vm.showButton
                      ? _c(
                          "v-button",
                          {
                            staticClass: "pricing-plans__button",
                            attrs: {
                              href: _vm.fullPrice,
                              element: "a",
                              target: "_blank",
                              variant: "secondary"
                            }
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(_vm.$t("button.fullPricing")) +
                                "\n\t\t\t\t"
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }